import { render, staticRenderFns } from "./best-offer.vue?vue&type=template&id=2885f7a8&scoped=true&"
import script from "./best-offer.vue?vue&type=script&lang=js&"
export * from "./best-offer.vue?vue&type=script&lang=js&"
import style0 from "./best-offer.vue?vue&type=style&index=0&id=2885f7a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885f7a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
